module.exports = "pegasus/assets/email1-image-2.png";